import styled from 'styled-components';
import { media } from 'common/responsive';

const Image = styled.img`
  max-height: 260px;
  transform: scale(0.8);
  position: relative;
  ${media.mobile`
    max-height: 260px;
  `};
  ${media.tablet`
  max-height: 500px;
  `};
`;
export default Image;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ImagedSection/Image.jsx